import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_BusinessUnit_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_BUSINESSUNIT_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB BusinessUnit Id',  columnResourceName: 'colId',            alignment: HorizAlignment.Left},  domainOptions: {} },
    BUSINESSUNIT_ID:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'BusinessUnit Id',     columnResourceName: 'colId',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    BUSINESSUNIT_NAME:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Business Name',       columnResourceName: 'colBusinessName',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMPANY_CODE:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Company Code',        columnResourceName: 'colCompanyCode',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DT:                 {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date',        columnResourceName: 'colCreatedDate',   alignment: HorizAlignment.Left}, domainOptions: {}},
    MODIFIED_DT:                {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified Date',       columnResourceName: 'colModifiedDate',  alignment: HorizAlignment.Left}, domainOptions: {}},
    MODIFIED_BY:                {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Modified By',         columnResourceName: 'colModifiedBy',    alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_IND:                {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Deleted Ind',         columnResourceName: 'colDeletedInd',    alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_DT:                 {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',        columnResourceName: 'colDeletedDate',   alignment: HorizAlignment.Left}, domainOptions: {}}
};

const BusinessUnitSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_BUSINESSUNIT_ID',
                id_ui: 'BUSINESSUNIT_ID',
                name:  'BUSINESSUNIT_NAME'

    },

    searchProviderFields: vUI_BusinessUnit_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_BusinessUnit',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const BusinessUnitSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "BusinessUnitSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'BUSINESSUNIT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'BUSINESSUNIT_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'BUSINESSUNIT_ID', 'BUSINESSUNIT_NAME', 'COMPANY_CODE', 'CREATED_DT', 'MODIFIED_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: BusinessUnitSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const BusinessUnitSearch: ISearch = {
    searchName: "Find BusinessUnit",
    renderOptions: {ui5ResourceId: "BusinessUnitSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [BusinessUnitSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("BusinessUnitBO", "BusinessUnit", BusinessUnitSearch, "Business Unit Search")

export {BusinessUnitSearch}